/* eslint-disable @typescript-eslint/no-empty-function */
export default function emptyFunction() {}
export async function emptyAsyncFunction() {}
